import React, { useCallback } from 'react';
import { useFocusEffect } from '@react-navigation/native';

import { useLastInteractedStore } from '../../../../context/LastInteractedStore';
import { useValidOrders } from '../../../../context/Order';
import { useReorderOrdersV2 } from '../../../ReorderScreen/hooks';
import { OrdersListWrapper } from '../../components';

export const DigitalOrders = () => {
  const lastInteractedStore = useLastInteractedStore();
  const { isFetchingOrders } = useValidOrders();

  const currentRestaurantId = lastInteractedStore?.restaurantId
    ? Number.parseInt(lastInteractedStore.restaurantId, 10)
    : undefined;

  const {
    orders,
    fetchInitialOrders,
    isFetchingInitialOrders,
    isFetchingMoreOrders,
    canFetchMoreOrders,
    mostRecentOrder,
    fetchMoreOrders,
  } = useReorderOrdersV2(currentRestaurantId);

  // ─── Effects ─────────────────────────────────────────────────────────
  // Fetch orders on screen focus.

  useFocusEffect(
    useCallback(() => {
      // Must wait for the last valid order to be fetched due to "canReorderAtRestaurant".
      if (isFetchingOrders) return;

      fetchInitialOrders();
    }, [isFetchingOrders, fetchInitialOrders]),
  );

  // ─────────────────────────────────────────────────────────────────────

  return (
    <OrdersListWrapper
      canReorder
      orders={orders}
      fetchMoreOrders={fetchMoreOrders}
      isFetchingInitialOrders={isFetchingInitialOrders}
      isFetchingMoreOrders={isFetchingMoreOrders}
      canFetchMoreOrders={canFetchMoreOrders}
      mostRecentOrder={mostRecentOrder}
    />
  );
};
